export enum ConversationType{
    DELIVERY_ACKNOWLEDGEMENT = 'DeliveryAcknowledgement',
    MESSAGE = 'Message',
    PARTICIPANT_CHANGED = 'ParticipantChanged',
    PROGRESS_INDICATOR = 'ProgressIndicator',
    QUEUE_POSITION = 'QueuePosition',
    READ_ACKNOWLEDGEMENT = 'ReadAcknowledgement',
    ROUTING_RESULT = 'RoutingResult',
    STREAMING_TOKEN = 'StreamingToken',
    TYPING_STARTED_INDICATOR = 'TypingStartedIndicator',
    TYPING_STOPPED_INDICATOR = 'TypingStoppedIndicator'

}

export enum EventMessageType {
    CONVERSATION_CLOSE_CONVERSATION,
    CONVERSATION_DELIVERY_ACKNOWLEDGEMENT,
    CONVERSATION_MESSAGE,
    CONVERSATION_PARTICIPANT_CHANGED,
    CONVERSATION_PROGRESS_INDICATOR,
    CONVERSATION_QUEUE_POSITION,
    CONVERSATION_READ_ACKNOWLEDGEMENT,
    CONVERSATION_ROUTING_RESULT,
    CONVERSATION_STREAMING_TOKEN,
    CONVERSATION_TYPING_STARTED_INDICATOR,
    CONVERSATION_TYPING_STOPPED_INDICATOR

}